import { query } from '@confluence/query-preloader-tools';

import { getReactionsQueryInfo } from './utils/data';

export function preloadPageReactions({ pageId, containerId, cloudId, contentType }) {
	const { query: reactionsQuery, queryVariables } = getReactionsQueryInfo(
		false,
		pageId,
		containerId,
		cloudId,
		contentType,
	);

	return query({
		query: reactionsQuery,
		variables: queryVariables,
	});
}
